export default __webpack_public_path__ + "static/media/BrandyMartins.3e3760ad.png";